// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3459":"70eb50a3","7098":"70eb50a3"}[chunkId] + ".chunk.css";
};